import { apiGet } from '../utils/axios';

const base_url = `/glossary`;

export const getTerms = () => {
  return apiGet(`${base_url}/terms`);
};
